import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { Children, cloneElement } from 'react';
import styled, { css } from 'styled-components';
import chroma from 'chroma-js';
var TableListWrapper = styled.table(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n  table-layout: ", ";\n  border: ", ";\n\n  & > tbody > tr {\n    border-bottom: ", ";\n\n    & > td {\n      padding: ", ";\n      padding-right: ", ";\n      \n      &:first-child {\n        padding-right: 1rem;\n      }\n    }\n  }\n"])), function (props) {
  return props.fixedLayout ? 'fixed' : 'auto';
}, function (props) {
  return props.bordered ? "1px solid ".concat(props.theme.colors.grey) : 'none';
}, function (props) {
  return props.bordered && props.rowBordered ? "1px solid ".concat(props.theme.colors.grey) : 'none';
}, function (props) {
  return props.padding || (props.bordered || props.noBorderWithPadding ? '0.75rem' : '0.25rem 0');
}, function (props) {
  return props.paddingRight;
});
var Item = styled.tr(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  & > td {\n    vertical-align: ", ";\n    background-color: ", ";\n  }\n"])), function (props) {
  return props.verticalAlign;
}, function (props) {
  return props.backgroundColor && chroma(props.theme.colors[props.backgroundColor]).alpha(props.backgroundColorOpacity).hex();
});
var Label = styled.td.attrs(function (props) {
  return _objectSpread({}, props.labelProps);
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  white-space: nowrap;\n  color: ", ";\n  text-align: ", ";\n  width: ", ";\n\n  ", "\n\n  @media only screen and (max-width: ", ") {\n    white-space: normal;\n  }\n"])), function (props) {
  return props.theme.colors.darkGrey;
}, function (props) {
  return props.align;
}, function (props) {
  return props.width;
}, function (props) {
  return props.boldLabel && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    color: ", ";\n    font-weight: bold;\n  "])), props.theme.colors.dark);
}, function (props) {
  var _props$theme$breakpoi;

  return (_props$theme$breakpoi = props.theme.breakpoints) === null || _props$theme$breakpoi === void 0 ? void 0 : _props$theme$breakpoi.sm;
});
var Content = styled.td(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  width: ", ";\n  text-align: ", ";\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.align;
});

var TableList = function TableList(_ref) {
  var children = _ref.children,
      _ref$rowBordered = _ref.rowBordered,
      rowBordered = _ref$rowBordered === void 0 ? true : _ref$rowBordered,
      _ref$bordered = _ref.bordered,
      bordered = _ref$bordered === void 0 ? false : _ref$bordered,
      _ref$noBorderWithPadd = _ref.noBorderWithPadding,
      noBorderWithPadding = _ref$noBorderWithPadd === void 0 ? false : _ref$noBorderWithPadd,
      labelAlign = _ref.labelAlign,
      labelWidth = _ref.labelWidth,
      contentAlign = _ref.contentAlign,
      contentWidth = _ref.contentWidth,
      style = _ref.style,
      tdPadding = _ref.tdPadding,
      paddingRight = _ref.paddingRight,
      className = _ref.className;
  var childProps = {
    labelAlign: labelAlign,
    labelWidth: labelWidth,
    contentAlign: contentAlign,
    contentWidth: contentWidth
  };
  var filteredChildProps = Object.keys(childProps).filter(function (key) {
    return childProps[key] !== undefined;
  }).reduce(function (accumulator, key) {
    return _objectSpread(_objectSpread({}, accumulator), {}, _defineProperty({}, key, childProps[key]));
  }, {});
  return /*#__PURE__*/React.createElement(TableListWrapper, {
    fixedLayout: Boolean(labelWidth),
    bordered: bordered,
    rowBordered: rowBordered,
    noBorderWithPadding: noBorderWithPadding,
    style: style,
    padding: tdPadding,
    paddingRight: paddingRight,
    className: className
  }, /*#__PURE__*/React.createElement("tbody", null, Children.map(children, function (child) {
    return child && /*#__PURE__*/cloneElement(child, filteredChildProps);
  }).filter(Boolean)));
};

TableList.Item = function (_ref2) {
  var children = _ref2.children,
      _ref2$className = _ref2.className,
      className = _ref2$className === void 0 ? '' : _ref2$className,
      style = _ref2.style,
      _ref2$label = _ref2.label,
      label = _ref2$label === void 0 ? '' : _ref2$label,
      _ref2$backgroundColor = _ref2.backgroundColor,
      backgroundColor = _ref2$backgroundColor === void 0 ? '' : _ref2$backgroundColor,
      _ref2$backgroundColor2 = _ref2.backgroundColorOpacity,
      backgroundColorOpacity = _ref2$backgroundColor2 === void 0 ? 1 : _ref2$backgroundColor2,
      _ref2$verticalAlign = _ref2.verticalAlign,
      verticalAlign = _ref2$verticalAlign === void 0 ? 'baseline' : _ref2$verticalAlign,
      _ref2$labelAlign = _ref2.labelAlign,
      labelAlign = _ref2$labelAlign === void 0 ? 'left' : _ref2$labelAlign,
      _ref2$labelWidth = _ref2.labelWidth,
      labelWidth = _ref2$labelWidth === void 0 ? null : _ref2$labelWidth,
      _ref2$contentAlign = _ref2.contentAlign,
      contentAlign = _ref2$contentAlign === void 0 ? 'left' : _ref2$contentAlign,
      _ref2$contentWidth = _ref2.contentWidth,
      contentWidth = _ref2$contentWidth === void 0 ? '100%' : _ref2$contentWidth,
      _ref2$boldLabel = _ref2.boldLabel,
      boldLabel = _ref2$boldLabel === void 0 ? false : _ref2$boldLabel,
      _ref2$labelProps = _ref2.labelProps,
      labelProps = _ref2$labelProps === void 0 ? {} : _ref2$labelProps;
  return /*#__PURE__*/React.createElement(Item, {
    verticalAlign: verticalAlign,
    backgroundColor: backgroundColor,
    backgroundColorOpacity: backgroundColorOpacity,
    className: className
  }, /*#__PURE__*/React.createElement(Label, {
    align: labelAlign,
    width: labelWidth,
    boldLabel: boldLabel,
    labelProps: labelProps
  }, label), /*#__PURE__*/React.createElement(Content, {
    align: contentAlign,
    width: contentWidth,
    style: style
  }, children));
};

export default TableList;